module.exports = "<div class=\"{{'sui-panel ' + cssClass}}\" [ngStyle]=\"alertStyle\" *ngIf=\"!isClosed && message && message.length\">\r\n    <div class=\"sui-padding\">\r\n        <span (click)=\"onClose(event)\" class=\"sui-closebtn\">&times;</span>\r\n        <h3 class=\"{{headerClass}}\" [ngStyle]=\"headingtStyle\">{{heading}}</h3>\r\n        <div class=\"{{messageClass}}\" [ngStyle]=\"messagetStyle\" [innerHTML]=\"message\"></div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/sui/sui.alert/sui.alert.component.html
// module id = 370
// module chunks = 0